import React from 'react';
import { HINT_IDS, HINT_MAP } from '../../hints/hints.config';
import './HelpCodex.css';

export default function HelpCodex({ seenHints, discoveredCount, totalHints = HINT_IDS.length, onClose }) {
  return (
    <div className="help-codex-overlay" onClick={onClose}>
      <div className="help-codex-panel" onClick={(e) => e.stopPropagation()}>
        <div className="help-codex-header">
          <h2 className="help-codex-title">Feature Guide</h2>
          <span className="help-codex-progress">{discoveredCount}/{totalHints} DISCOVERED</span>
          <button className="help-codex-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="help-codex-entries">
          {HINT_IDS.map((id) => {
            const discovered = !!seenHints[id];
            const def = HINT_MAP[id];
            return (
              <div key={id} className={`help-codex-entry${discovered ? '' : ' help-codex-entry--locked'}`}>
                {discovered ? (
                  <>
                    <div className="help-codex-entry-title">{def.title}</div>
                    <div className="help-codex-entry-body">{def.body}</div>
                  </>
                ) : (
                  <>
                    <div className="help-codex-entry-title">???</div>
                    <div className="help-codex-entry-body">Undiscovered feature. Keep exploring to find it.</div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
